var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconProfileEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8327 0.333496H3.16602C2.50297 0.333496 1.86709 0.596888 1.39825 1.06573C0.929408 1.53457 0.666016 2.17045 0.666016 2.8335V11.1668C0.666016 11.8299 0.929408 12.4658 1.39825 12.9346C1.86709 13.4034 2.50297 13.6668 3.16602 13.6668H14.8327C15.4957 13.6668 16.1316 13.4034 16.6004 12.9346C17.0693 12.4658 17.3327 11.8299 17.3327 11.1668V2.8335C17.3327 2.17045 17.0693 1.53457 16.6004 1.06573C16.1316 0.596888 15.4957 0.333496 14.8327 0.333496ZM14.2743 2.00016L8.99935 5.9585L3.72435 2.00016H14.2743ZM14.8327 12.0002H3.16602C2.945 12.0002 2.73304 11.9124 2.57676 11.7561C2.42048 11.5998 2.33268 11.3878 2.33268 11.1668V3.04183L8.49935 7.66683C8.6436 7.77501 8.81904 7.8335 8.99935 7.8335C9.17966 7.8335 9.3551 7.77501 9.49935 7.66683L15.666 3.04183V11.1668C15.666 11.3878 15.5782 11.5998 15.4219 11.7561C15.2657 11.9124 15.0537 12.0002 14.8327 12.0002Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconProfileEnvelope);
export default __webpack_public_path__ + "static/media/TH-Icon-Profile-Envelope.9ace1dea6e74f8b547566b8cbbb246c0.svg";
export { ForwardRef as ReactComponent };